<template>
	<div class="wrapper package-page">
		<!-- Header -->
		<Header />
		<!-- HeaderMenu -->
		<HeaderMenu />

		<div class="contents">
			<div class="layout">
				<div class="pc-only main">
					<h1>{{ $t("PACKAGE") }}</h1>
					<div class="balance">
						<h2>{{ $t("BALANCE") }}</h2>
						<div class="total-amount"><span>100</span> USDT</div>
						<ul class="list">
							<li>
								<h3>{{ $t("PRINCIPAL") }}</h3>
								<div class="amount">
									<span>10</span>
									USDT
								</div>
							</li>
							<li>
								<h3>{{ $t("PROFIT") }}</h3>
								<div class="amount">
									<span>10</span>
									USDT
								</div>
							</li>
							<li>
								<h3>{{ $t("TOTAL PROFIT") }}</h3>
								<div class="amount">
									<span>10</span>
									USDT
								</div>
							</li>
						</ul>
					</div>
					<div class="package">
						<div class="ttl">
							<span>
								<img
									src="../assets/img/package-img.svg"
									alt=""
								/>
							</span>
							{{ $t("BRONZE PACKAGE") }}
						</div>
						<div class="package-btn">
							<span class="link-over" v-on:click="show">{{
								$t("SELECT A PACKAGE")
							}}</span>
						</div>
					</div>
				</div>
				<div class="left">
					<div class="pc-only">
						<Sidebar />
					</div>
				</div>
				<div class="right">
					<div class="sp-only">
						<h1>{{ $t("PACKAGE") }}</h1>
						<div class="balance">
							<h2>{{ $t("BALANCE") }}</h2>
							<div class="total-amount">
								<span>100</span> USDT
							</div>
							<ul class="list">
								<li>
									<h3>{{ $t("PRINCIPAL") }}</h3>
									<div class="amount">
										<span>10</span>
										USDT
									</div>
								</li>
								<li>
									<h3>{{ $t("PROFIT") }}</h3>
									<div class="amount">
										<span>10</span>
										USDT
									</div>
								</li>
								<li>
									<h3>{{ $t("TOTAL PROFIT") }}</h3>
									<div class="amount">
										<span>10</span>
										USDT
									</div>
								</li>
							</ul>
						</div>
						<div class="package">
							<div class="ttl">
								<span>
									<img src="img/package-img.svg" alt="" />
								</span>
								{{ $t("BRONZE PACKAGE") }}
							</div>
							<div class="package-btn">
								<span class="link-over" v-on:click="show">{{
									$t("SELECT A PACKAGE")
								}}</span>
							</div>
						</div>
					</div>
					<div class="table">
						<h2>Payment History</h2>
						<table>
							<tr>
								<th>{{ $t("DATE") }}</th>
								<th>{{ $t("PACKAGE") }}</th>
								<th>{{ $t("AMOUNT") }}</th>
								<th>{{ $t("STATUS") }}</th>
							</tr>
							<tr>
								<td>2020.04.10<br />12:23:32</td>
								<td>
									STAGE1~8（英語）<br />ステージ1~8（日本語）
								</td>
								<td>0.01USDT</td>
								<td class="cancel">{{ $t("CANCEL") }}</td>
							</tr>
							<tr>
								<td>2020.04.10<br />12:23:32</td>
								<td>
									STAGE1~8（英語）<br />ステージ1~8（日本語）
								</td>
								<td>0.01USDT</td>
								<td>{{ $t("DONE") }}</td>
							</tr>
							<tr>
								<td>2020.04.10<br />12:23:32</td>
								<td>
									STAGE1~8（英語）<br />ステージ1~8（日本語）
								</td>
								<td>0.01USDT</td>
								<td>{{ $t("DONE") }}</td>
							</tr>
							<tr>
								<td>2020.04.10<br />12:23:32</td>
								<td>
									STAGE1~8（英語）<br />ステージ1~8（日本語）
								</td>
								<td>0.01USDT</td>
								<td>{{ $t("DONE") }}</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>
		<!-- /.contents -->

		<modal
			name="packageModal"
			:resizable="true"
			:adaptive="true"
			:scrollable="true"
			width="90%"
			height="auto"
		>
			<div class="modal-box">
				<div class="modal-ttl">
					<p>{{ $t("SELECT A PACKAGE") }}</p>
					<p>
						{{ $t("BALANCE") }}<br />
						<b><span>1000</span>USDT</b>
					</p>
				</div>
				<div class="select-box">
					<div class="input-area">
						<label
							class="label"
							v-bind:class="{ change: changeColor }"
							for="checkbox_1"
						>
							<input
								type="checkbox"
								name=""
								id="checkbox_1"
								v-model="changeColor"
							/>
							<ul class="list">
								<li class="img">
									<img
										src="../assets/img/package-img.svg"
										alt=""
									/>
								</li>
								<li class="txt">
									<p>3 main chain plans</p>
									<span
										>(low risk plans with low
										dividends)</span
									>
								</li>
							</ul>
							<span class="circle" id="check_circle1">
								<span class="bar"></span>
							</span>
						</label>
					</div>
					<div class="input-area">
						<label
							class="label"
							v-bind:class="{ change: changeColor2 }"
							for="checkbox2"
						>
							<input
								type="checkbox"
								name=""
								id="checkbox2"
								v-model="changeColor2"
							/>
							<ul class="list">
								<li class="img">
									<img
										src="../assets/img/package-img.svg"
										alt=""
									/>
								</li>
								<li class="txt">
									<p>Combined 10-chainplan</p>
									<span
										>(high risk plan with high
										dividends)</span
									>
								</li>
							</ul>
							<span class="circle" id="check_circle2">
								<span class="bar"></span>
							</span>
						</label>
					</div>
				</div>
				<div class="amount">
					<div
						class="total-number"
						v-bind:class="{ isActive: changeColor || changeColor2 }"
					>
						<p class="name">
							{{ $t("CURRENT INVESTMENT AMOUNT") }}：
						</p>
						<p class="number"><span>500</span>USDT</p>
					</div>
					<div
						class="input-area"
						v-bind:class="{ isActive: changeColor || changeColor2 }"
					>
						<label class="label" for="modal_amount">
							<input
								type="text"
								name=""
								id="modal_amount"
								v-model="amount"
								placeholder=" "
							/>
							<span class="group-label">{{
								$t("CHARGE AMOUNT")
							}}</span>
							<span class="stage">STAGE2</span>
						</label>
						<span
							class="circle"
							id="modal_amount_circle"
							v-bind:class="addClass"
						>
							<span class="bar"></span>
						</span>
					</div>
				</div>
				<div
					class="btn"
					v-bind:class="{ isActive: changeColor } && addClass"
				>
					<button v-on:click="hide" type="button" class="link-over">
						{{ $t("PAYMENT") }}
					</button>
				</div>
			</div>
		</modal>

		<Footer title="Stage" />
	</div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
	name: "Package",
	components: {
		Header,
		HeaderMenu,
		Sidebar,
		Footer,
	},
	data: () => {
		return {
			title: "Package",
			changeColor: false,
			changeColor2: false,
			amount: "",
		};
	},
	methods: {
		show: function () {
			this.$modal.show("packageModal");
		},
		hide: function () {
			this.$modal.hide("packageModal");
		},
	},
	computed: {
		addClass() {
			if (this.amount !== "") {
				return "done";
			} else {
				return "";
			}
		},
	},
	mounted: function () {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", vh + "px");

		var ua = navigator.userAgent.toLowerCase();
		var isiOS = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
		if (isiOS) {
			var viewport = document.querySelector('meta[name="viewport"]');
			if (viewport) {
				var viewportContent = viewport.getAttribute("content");
				viewport.setAttribute(
					"content",
					viewportContent + ", user-scalable=no"
				);
			}
		}
	},
};
</script>
